import http from "../http-common";
/* eslint-disable */
class SettingTelemedicineService {
  getSetting() {
    return http.get("/setting-telemedicine", {
      headers: {
        "Content-type": "application/json",
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
    });
  }

  create(data) {
    var bodyFormData = new FormData();
    bodyFormData.append("durasi_konsultasi", data.durasi_konsultasi);
    bodyFormData.append("nama_apoteker", data.nama_apoteker);
    bodyFormData.append("no_telepon_apoteker", data.no_telepon_apoteker);
    bodyFormData.append("api_key", data.api_key);
    bodyFormData.append("number_key", data.number_key);

    return http.post("/setting-telemedicine", bodyFormData, {
      headers: {
        "Content-type": "application/json",
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
    });
  }

  update(id, data) {
    var bodyFormData = new FormData();
    bodyFormData.append("durasi_konsultasi", data.durasi_konsultasi);
    bodyFormData.append("nama_apoteker", data.nama_apoteker);
    bodyFormData.append("no_telepon_apoteker", data.no_telepon_apoteker);
    bodyFormData.append("api_key", data.api_key);
    bodyFormData.append("number_key", data.number_key);

    return http.put(`/setting-telemedicine/${id}`, bodyFormData, {
      headers: {
        "Content-type": "application/json",
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
    });
  }
}

export default new SettingTelemedicineService();
